import embedded from './Esign';

export const useEmbeddedInstance = () => {
  const instance = embedded.getInstance();

  return instance;
};

export default useEmbeddedInstance;